<template>
	
<div class="treatment">

	<div class="treatment-title">{{ treatment.title }} <small>{{ section.summary.treatment.title }}</small></div>

	<div class="treatment-benefits">

		<div class="treatment-benefits-text">

			<div class="treatment-benefits-text-title">Strengthens your bone</div>

			<div class="treatment-benefits-text-html" v-html="benefits"></div>

		</div>

		<div class="treatment-benefits-chances">

			<div class="treatment-benefits-text-title">Lowers your chance of a broken bone</div>

			<div class="treatment-benefits-chances-item" v-for="item in chances" :key="item">

				<div class="treatment-benefits-chances-item-text">{{ more.chances[item]}}</div>

				<div class="treatment-benefits-chances-item-tick" :class="{'is-active': treatment[item] >= 5}"></div>
				<div class="treatment-benefits-chances-item-tick" :class="{'is-active': treatment[item] >= 4}"></div>
				<div class="treatment-benefits-chances-item-tick" :class="{'is-active': treatment[item] >= 3}"></div>
				<div class="treatment-benefits-chances-item-tick" :class="{'is-active': treatment[item] >= 2}"></div>
				<div class="treatment-benefits-chances-item-tick" :class="{'is-active': treatment[item] >= 1}"></div>

			</div>

		</div>

	</div>

	<div class="treatment-subtitle">Side-effects and long-term issues</div>

	<div class="treatment-effects">

		<div class="treatment-effects-row" v-if="treatment.effects.length">
			<div class="treatment-effects-item is-head">Possible side effects</div>
			<div class="treatment-effects-item is-head">Chance of getting side effect</div>
			<div class="treatment-effects-item is-head">What can I do</div>
		</div>

		<div v-for="(effect, index) in treatment.effects" :key="'e' + index" class="treatment-effects-row">

			<div class="treatment-effects-item">{{ effect.title }}</div>
			<div class="treatment-effects-item">{{ effect.chance }}</div>
			<div class="treatment-effects-item">{{ effect.advice }}</div>

		</div>

		<div class="treatment-effects-row" v-if="treatment.issues.length">
			<div class="treatment-effects-item is-head">Possible long-term issues</div>
			<div class="treatment-effects-item is-head">Chance of getting long-term issue</div>
			<div class="treatment-effects-item is-head">What can I do</div>
		</div>

		<div v-for="(effect, index) in treatment.issues" :key="'i' + index" class="treatment-effects-row">

			<div class="treatment-effects-item">{{ effect.title }}</div>
			<div class="treatment-effects-item">{{ effect.chance }}</div>
			<div class="treatment-effects-item">{{ effect.advice }}</div>

		</div>

	</div>
	
	<div class="treatment-subtitle">Practical Considerations</div>

	<div class="treatment-practical-items">

		<div class="treatment-practical-items-item">

			<div class="treatment-practical-items-item-head">How it's taken</div>

			<div class="treatment-practical-items-item-body">

				{{ treatment.method }}

				<small v-if="treatment.methodText" v-html="treatment.methodText"></small>

			</div>

		</div>

		<div class="treatment-practical-items-item">

			<div class="treatment-practical-items-item-head">Frequency</div>

			<div class="treatment-practical-items-item-body">

				{{ treatment.frequency }}

			</div>

		</div>

		<div class="practical-items-item">

			<div class="treatment-practical-items-item-head">Course Duration</div>

			<div class="treatment-practical-items-item-body">

				{{ treatment.duration }}

			</div>

		</div>

	</div>

</div>

</template>

<script>

export default {

	props: ['section'],

	data: function() {

		return {
			chances: ['spine', 'hip', 'other']
		}

	},

	computed: {

		benefits: function() {

			return this.treatment.benefit.replace(/{{bullet}}/g, '<span class="bullet"></span>')

		},

		more: function() {

			return this.$_.findWhere(this.$store.getters['data/aid/sections'], {
				id: 4
			}).treatment.more

		},

		named: function() {

			return this.$store.getters['logic/variable/named']

		},

		treatment: function() {

			var section = this.$_.findWhere(this.$store.getters['data/aid/sections'], {
				id: 4
			}).treatment

			var selected = ''

			this.$_.each(section, function(treatment, key) {

				if (treatment.id === this.values[this.named['aid.treatment']]) selected = key

			}.bind(this))

			return section[selected]

		}

	}
	
}

</script>

<style scoped>

.treatment {
	border-bottom: 1px solid var(--aid-color);
	margin-bottom: 32px;
}

.is-pdf .treatment {
	border-bottom: 0px;
	margin-bottom: 30px;
}

.treatment-title {
	color: #343434;
	margin-bottom: 42px;
	padding-left: 80px;
	padding-top: 10px;
	font-size: 20px;
	font-weight: 600;
	text-transform: uppercase;
}

.is-pdf .treatment-title {
	font-size: 16px;
}

.treatment-title:before {
	content: ' ';
	width: 64px;
	height: 64px;
	border-radius: 32px;
	background-color: #F8A533;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: 40px auto;
	position: absolute;
	left: 0px;
	top: 0px;
	background-image: url(~@/assets/aid/improve/icon.treatment.svg);
}

.treatment-title small {
	display: block;
	font-weight: 300;
	margin-top: 5px;
}

.is-pdf .treatment-title small {
	font-size: 14px;
}

.treatment-benefits {
	display: flex;
	margin-bottom: 32px;
}

.is-pdf .treatment-benefits {
	margin-bottom: 10px;
}

.treatment-benefits-text {
	width: 50%;
}

.treatment-benefits-text-title {
	color: #343434;
	font-weight: 600;
	font-size: 20px;
	margin-bottom: 32px;
}

.is-pdf .treatment-benefits-text-title {
	font-size: 16px;
	margin-bottom: 10px;
}

.treatment-benefits-text-html {
	color: #343434;
	font-size: 18px;
	font-weight: 600;
	line-height: 22px;
}

.is-pdf .treatment-benefits-text-html {
	font-size: 14px;
}

.treatment-benefits-text-html >>> .bullet {
	width: 22px;
	height: 22px;
	display: inline-block;
	vertical-align: middle;
	background-size: contain;
	background-position: 0% 0px;
	background-repeat: no-repeat;
	background-size: 16px 16px;
	background-image: url(~@/assets/aid/common/bullet.png);
}

.is-patient .treatment-benefits-text-html >>> .bullet {
	background-image: url(~@/assets/aid/common/link.png);
}

@media print {

	.treatment-benefits-text-html >>> .bullet:before {
		content: '-';
	}

}

.treatment-benefits-chances-item {
	display: flex;
	margin-bottom: 5px;
}

.treatment-benefits-chances-item:last-child {
	margin-bottom: 0px;
}

.treatment-benefits-chances-item-text {
	color: #343434;
	font-size: 18px;
	line-height: 26px;
	width: 300px;
}

.is-pdf .treatment-benefits-chances-item-text {
	font-size: 14px;
}

.treatment-benefits-chances-item-tick {
	width: 26px;
	margin: 0px 5px;
	height: 26px;
	border-radius: 13px;
	background-color: #F6F6F6;
}

.treatment-benefits-chances-item-tick.is-active {
	background-color: #F8A533;
	background-image: url(~@/assets/aid/common/icon.tick.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.treatment-subtitle {
	color: #343434;
	border-top: 1px solid #ddd;
	font-weight: 600;
	padding-top: 32px;
	font-size: 20px;
	margin-bottom: 32px;
}

.is-pdf .treatment-subtitle {
	border-top: 0px;
	padding-top: 0px;
	margin-bottom: 10px;
	font-size: 16px;
}

.treatment-effects-row {
	display: flex;
	flex-direction: row;
	width: 100%;
	margin-bottom: 16px;
}

.treatment-effects-row:last-child {
	margin-bottom: 32px;
}

.is-pdf .treatment-effects-row:last-child {
	margin-bottom: 10px;
}

.treatment-effects-item {
	flex-grow: 1;
	font-size: 18px;
	line-height: 22px;
	font-weight: 300;
	color: #343434;
	flex-shrink: 0;
	flex-basis: 0;
	width: calc(33.3% - 22px);
}

.is-pdf .treatment-effects-item {
	font-size: 14px;
	line-height: 16px;;
}

.treatment-effects-item.is-head {
	font-weight: 600;
}

.treatment-effects-item:nth-child(2) {
	margin: 0px 32px;
}

.treatment-practical-items {
	display: flex;
	flex-direction: row;
	width: 100%;
	margin-bottom: 32px;
}

.is-pdf .treatment-practical-items {
	margin-bottom: 10px;
}

.treatment-practical-items-item {
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
	width: calc(33.3% - 22px);
}

.treatment-practical-items-item:nth-child(2) {
	margin: 0px 32px;
}

.treatment-practical-items-item-head {
	color: #343434;
	font-weight: 600;
	font-size: 18px;
	margin-bottom: 16px;
	border-radius: 6px 6px 0px 0px;
}

.is-pdf .treatment-practical-items-item-head {
	font-size: 14px;
}

.treatment-practical-items-item-body {
	font-size: 18px;
	line-height: 22px;
	color: #343434;
	font-weight: 300;
}

.is-pdf .treatment-practical-items-item-body {
	font-size: 14px;
	line-height: 16px;
}

.treatment-practical-items-item-body small {
	font-size: 18px;
	line-height: 22px;
	font-weight: 300;
	display: block;
	margin-top: 16px;
}

.is-pdf .treatment-practical-items-item-body small {
	font-size: 14px;
	line-height: 16px;
}

</style>